<template>
	<div>
		<div v-if="id">
			<pagetitle>{{ role.name }} - Rol</pagetitle>
			<div class="row bg-white">
				<div class="col-12 p-0">
					<div class="accordion" id="accordionRole">
						<div class="card">
							<div class="card-header" id="headingOne" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
								<h2 class="mb-0">
									Rechten
								</h2>
							</div>

							<div id="collapseOne" class="collapse show" aria-labelledby="headingOne" data-parent="#accordionRole">
								<div class="card-body">
									<div class="row mb-4">
										<div class="col-8">
											<select class="form-control" id="rolePermission">
												<option value="false">-- Kies een permissie --</option>
												<option :value="permission.id" v-for="(permission, index) in allpermissions" :key="index">{{ permission.name }}</option>
											</select>
										</div>
										<div class="col-4">
											<a href="#" class="btn btn-theme" @click="addPermissionToRole()">Toevoegen</a>
										</div>
									</div>

									<table class="table" v-if="permissionsresult">
										<thead>
											<tr>
												<th scope="col"></th>
												<th scope="col">Naam</th>
												<th scope="col">Omschrijving</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(permission, index) in permissionsresult" :key="index">
												<td><a href="#"><i class="fa fa-trash" @click="removePermissionFromRole(permission.id)"></i> </a></td>
												<td>{{ permission.name }}</td>
												<td>{{ permission.description }}</td>
												<td><a :href="'/permission/'+permission.id" class="btn btn-theme">Open</a></td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
						<div class="card">
							<div class="card-header" id="headingTwo" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
								<h2 class="mb-0">
									Medewerkers met deze rol
								</h2>
							</div>
							<div id="collapseTwo" class="collapse" aria-labelledby="headingTwo" data-parent="#accordionRole">
								<div class="card-body">
									<div class="row mb-4">
										<div class="col-8">
											<select class="form-control" id="roleUser">
												<option value="false">-- Kies een medewerker --</option>
												<option :value="user.id" v-for="(user, index) in users" :key="index">{{ user.firstname }} {{ user.lastname }}</option>
											</select>
										</div>
										<div class="col-4">
											<a href="#" class="btn btn-theme" @click="addUserToRole()">Toevoegen</a>
										</div>
									</div>
									<table class="table" v-if="role.users">
										<thead>
											<tr>
												<th scope="col">&nbsp;</th>
												<th scope="col" width="20%">Foto</th>
												<th scope="col">Voornaam</th>
												<th scope="col">Achternaam</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(user, index) in role.users" :key="index">
													<td>
														<a href="#" @click="removeUserFromRole(user.id)"><i class="fa fa-trash"></i> </a>
													</td>
													<td>
														<a 	:href="'/profile/'+user.id">
															<img class="w-100" :src="user.profile_image" :alt="user.firstname + ' '+ user.lastname">
														</a>
													</td>
													<td>
														<a :href="'/profile/'+user.id" v-html="user.firstname"></a>
													</td>
													<td>
														<a :href="'/profile/'+user.id" v-html="user.lastname"></a>
													</td>

													<td>
														<a :href="'/profile/'+user.id" class="btn btn-theme">Open</a>
													</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>

						<div class="card">
							<div class="card-header" id="headingThree" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
								<h2 class="mb-0">
									Berichttypen
								</h2>
							</div>
							<div id="collapseThree" class="collapse" aria-labelledby="headingThree" data-parent="#accordionRole">
								<div class="card-body">
									<div class="row mb-4">
										<div class="col-8">
											<select class="form-control" id="roleMessagetype">
												<option value="false">-- Kies een berichttype --</option>
												<option :value="messagetype.id" v-for="(messagetype, index) in allmessagetypes" :key="index">{{ messagetype.title }}</option>
											</select>
										</div>
										<div class="col-4">
											<a href="#" class="btn btn-theme" @click="addMessagetypeToRole()">Toevoegen</a>
										</div>
									</div>
									<table class="table" v-if="allmessagetypes">
										<thead>
											<tr>
												<th scope="col"></th>
												<th scope="col">Naam</th>
												<th scope="col"></th>
											</tr>
										</thead>
										<tbody>
											<tr v-for="(messagetype, index) in role.messagetypes" :key="index">
												<td><a href="#" @click="removeMessagetypeFromRole(messagetype.id)"><i class="fa fa-trash"></i> </a></td>
												<td>{{ messagetype.title }}</td>
												<td>
													<a :href="'/messagetype/'+messagetype.id" class="btn btn-theme">Open</a>
												</td>
											</tr>
										</tbody>
									</table>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<div v-else>
			<pagetitle>Rollen</pagetitle>
			<div class="row bg-white">
				<div class="col-12">
					<table class="table" v-if="rolesresult">
						<thead>
							<tr>
								<th scope="col">Naam</th>
								<th scope="col"></th>
							</tr>
							<tr>
								<th scope="col"><input type="text" v-model="search.name" placeholder="naam" class="form-control"></th>
								<th scope="col">
									<a href="#" @click="addRole()" class="btn btn-theme">Toevoegen</a>
								</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(role, index) in rolesresult" :key="index">
								<td>{{ role.name }}</td>
								<td><a :href="'/role/'+role.id" class="btn btn-theme">Open</a></td>
							</tr>
						</tbody>
					</table>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {

name: 'roles',
	props:{
		id:{
			required: false,
			default: false
		},
	},
	data () {
		return {
			role 	: {},
			roles 	: [],
			allpermissions 	: [],
			allmessagetypes : [],
			search 	: {},
			users : [],
		}
	},
	computed:{
		rolesresult : function(){
			// search roles with name contain
			if(this.search.name){
				let search = this.search;
				let roles = [];
				
				if(this.search.name.toLowerCase().length > 0){
					this.roles.forEach(function(role) {
						if(role.name.toLowerCase().includes(search.name.toLowerCase())){
							roles.push(role);
						}
					});
					return roles;
				}
			}

			return this.roles;
		},
		permissionsresult : function(){
			if(this.role.permissions){
				if(this.role.permissions.length>0){
					return this.role.permissions;
				}
			}
			return false;
		},
	},
	methods:{
		addRole : function(){
			this.$store.dispatch("addNewRole", {'name': this.search.name})
			.then(data=>{
            	this.$store.dispatch("get",this.$store.state.endpoint+'roles?token='+this.$store.state.token)
			    .then(data=>{  
			        this.roles=data.data.data;
			    }) 
			    .catch(error=>{
			        if(error.request.status == 401){
			            this.error=true;
			            this.error_msg="invalid login details";
			        }
			    });
        	})
        	.catch(error=>{
        		console.log('error', error);
        	});
		},

		addPermissionToRole : function(){
			if(document.getElementById('rolePermission').value){
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'addPermissionToRole?token='+this.$store.state.token,details:{'role_id':this.id, 'permission_id' : document.getElementById('rolePermission').value}})
				.then(data=>{
                	this.$store.dispatch("getRole", this.id)
				    .then(data=>{  
				        this.role=data.data.data;
				        window.console.log('data',data.data.data);
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
            	})
            	.catch(error=>{
            		console.log('error', error);
            	});
			}
		},

		removePermissionFromRole : function(permission_id){
			if(document.getElementById('rolePermission').value){
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'removePermissionFromRole?token='+this.$store.state.token , details:{'role_id':this.id, 'permission_id' : permission_id}})
				.then(data=>{
                	this.$store.dispatch("get", this.$store.state.endpoint+'roles/'+this.id+'?token='+this.$store.state.token )
				    .then(data=>{  
				        this.role=data.data.data;
				        window.console.log('data',data.data.data);
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
            	})
            	.catch(error=>{
            		console.log('error', error);
            	});
			}
		},

		addUserToRole : function(){
			if(document.getElementById('roleUser').value){
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'addUserToRole?token='+this.$store.state.token , details:{'role_id':this.id, 'user_id' : document.getElementById('roleUser').value}})
				.then(data=>{
                	this.$store.dispatch("getRole",this.$store.state.endpoint+'roles/'+this.id+'?token='+this.$store.state.token )
				    .then(data=>{  
				        this.role=data.data.data;
				        window.console.log('data',data.data.data);
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
            	})
            	.catch(error=>{
            		console.log('error', error);
            	});
			}
		},

		removeUserFromRole : function(user_id){
			if(document.getElementById('roleUser').value){
				this.$store.dispatch("post",{endpoint:this.$store.state.endpoint+'removeUserFromRole?token='+this.$store.state.token,details:{'role_id':this.id, 'user_id' : user_id}})
				.then(data=>{
					if(data.data.code == "-1"){
						this.showErrormessage(data.data.msg);
					}else{
	                	this.$store.dispatch("getRole", this.id)
					    .then(data=>{  
					        this.role=data.data.data;
					        window.console.log('data',data.data.data);
					    }) 
					    .catch(error=>{
					        if(error.request.status == 401){
					            this.error=true;
					            this.error_msg="invalid login details";
					        }
					    });
					}
            	})
            	.catch(error=>{
            		console.log('error', error);
            	});
			}
		},
		removeMessagetypeFromRole : function(messagetype_id){
			if(document.getElementById('roleUser').value){
				this.$store.dispatch("removeMessagetypeFromRole",{'role_id':this.id, 'messagetype_id' : messagetype_id})
				.then(data=>{
                	this.$store.dispatch("getRole", this.id)
				    .then(data=>{  
				        this.role=data.data.data;
				        window.console.log('data',data.data.data);
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
            	})
            	.catch(error=>{
            		console.log('error', error);
            	});
			}
		},
		addMessagetypeToRole : function(){
			if(document.getElementById('roleMessagetype').value){
				this.$store.dispatch("addMessagetypeToRole",{'role_id':this.id, 'messagetype_id' : document.getElementById('roleMessagetype').value})
				.then(data=>{
                	this.$store.dispatch("getRole", this.id)
				    .then(data=>{  
				        this.role=data.data.data;
				        window.console.log('data',data.data.data);
				    }) 
				    .catch(error=>{
				        if(error.request.status == 401){
				            this.error=true;
				            this.error_msg="invalid login details";
				        }
				    });
            	})
            	.catch(error=>{
            		console.log('error', error);
            	});
			}
		},
	},
	created(){
	    if(this.id){
			this.$store.dispatch("getRole", this.id)
		    .then(data=>{  
		        this.role=data.data.data;
		        window.console.log('data',data.data.data);
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });

		    this.$store.dispatch("get", this.$store.state.endpoint+'permissions?token='+this.$store.state.token)
		    .then(data=>{  
		        this.allpermissions=data.data.data;
		        window.console.log('data',data.data.data);
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });

		    this.$store.dispatch("get", this.$store.state.endpoint+'messagetypes?token='+this.$store.state.token )
		    .then(data=>{  
		        this.allmessagetypes=data.data.data;
		        window.console.log('data',data.data.data);
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });

		    this.$store.dispatch("get" , this.$store.state.endpoint+'users?token='+this.$store.state.token)
			    .then(data=>{  
			        this.users=data.data.data;
			        window.console.log('data',data); 
			       
			    }) 
			    .catch(error=>{
			        if(error.request.status == 401){
			            this.error=true;
			            this.error_msg="invalid login details";
			        }
			        // window.console.log(error.request.response);
			        
			    });
		}else{
		    this.$store.dispatch("get",this.$store.state.endpoint+'roles?token='+this.$store.state.token)
		    .then(data=>{  
		        this.roles=data.data.data;
		        window.console.log('data',data.data.data);
		       
		    }) 
		    .catch(error=>{
		        if(error.request.status == 401){
		            this.error=true;
		            this.error_msg="invalid login details";
		        }
		    });
		}
	}
}
</script>

<style lang="css" scoped>
</style>